import React, { EventHandler, MouseEvent } from 'react';

import styled from '../references';

import { CheckboxDeny, CheckboxActive, CheckboxInactive, CheckboxIndeterminate } from '../../icons';

export interface Props {
  className?: string;
  onClick?: EventHandler<MouseEvent<SVGElement>>;
  value?: 'active' | 'deny' | 'intermediate' | 'unselected';
}

const themedCheckboxIcon = (
  svg: typeof CheckboxActive | typeof CheckboxInactive | typeof CheckboxIndeterminate,
) => styled(svg).attrs<Props & { fill: string }>(props => ({
  fill: !props.value ? props.theme.colors.foregroundInactive : props.theme.colors.foreground,
}))<Props>`
  :hover {
    fill: ${props => props.theme.colors.foregroundActive};
  }
  fill: ${props => props.fill};
`;

const ThemedCheckboxActiveIcon = themedCheckboxIcon(CheckboxActive);
const ThemedCheckboxInactiveIcon = themedCheckboxIcon(CheckboxInactive);
const ThemedCheckboxIndeterminateIcon = themedCheckboxIcon(CheckboxIndeterminate);
const ThemedCheckboxDenyIcon = themedCheckboxIcon(CheckboxDeny);

export const Checkbox: React.FC<Props> = props => {
  const {
    className,
    onClick = () => {
      return;
    },
    value = null,
  } = props;
  let Icon;

  switch (value) {
    case 'active':
      Icon = ThemedCheckboxActiveIcon;
      break;

    case 'deny':
      Icon = StyledThemedCheckboxDenyIcon;
      break;

    case 'intermediate':
      Icon = ThemedCheckboxIndeterminateIcon;
      break;

    case 'unselected':
    default:
      Icon = ThemedCheckboxInactiveIcon;
      break;

    case undefined:
      return null;
  }

  return <Icon className={className} onClick={onClick} />;
};

const StyledThemedCheckboxDenyIcon = styled(ThemedCheckboxDenyIcon)`
  fill: ${props => props.theme.colors.danger};

  :hover {
    fill: ${props => props.theme.colors.dangerDark};
  }
`;

export default Checkbox;
